import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      role="contentinfo"
      aria-label="Pied de page du site"
      className="bg-appines-dark text-gray-300 mt-12"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img
                src="/logo-appines.png"
                alt="App'Ines"
                className="w-7 h-7 object-contain"
              />
              <span className="text-white font-semibold text-base">App'Ines</span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              L'app de recrutement en libéral et salariat des pros de santé.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-3">Données</h3>
            <div className="flex gap-2 text-sm text-gray-400 leading-relaxed">
              <ShieldCheck className="w-4 h-4 text-appines-main flex-shrink-0 mt-0.5" aria-hidden="true" />
              <p>
                Les grilles indiciaires et primes sont issues des barèmes officiels de la fonction publique hospitalière française. Les estimations sont anonymes et aucune donnée personnelle n'est conservée sans ton consentement explicite.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-3">Informations légales</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-gray-400 hover:text-appines-main transition-colors"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <a
                  href="https://appines.fr/politique-de-confidentialite"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-appines-main transition-colors"
                >
                  Politique de confidentialité
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center text-xs text-gray-500">
          <p>&copy; 2026 App'Ines. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
